module.exports = __webpack_public_path__ + "./assets/img/marketing.8b92dcd4.png";